export const SEND_QUICK_ACTION_REQUEST = "SEND_QUICK_ACTION_REQUEST";
export const SEND_QUICK_ACTION_SUCCESS = "SEND_QUICK_ACTION_SUCCESS";
export const SEND_QUICK_ACTION_FAILURE = "SEND_QUICK_ACTION_FAILURE";

export const GET_MAIN_MENU = "GET_MAIN_MENU";
export const GET_MAIN_MENU_SUCCESS = "GET_MAIN_MENU_SUCCESS";
export const GET_MAIN_MENU_FAILURE = "GET_MAIN_MENU_FAILURE";